import alt from '../alt';
import modalAction from './modalAction';

class permissionAction {
    constructor() {
        this.generateActions(
            'processing',
            'permission',
        );
    }

    getPermission() {
       
        if (sessionStorage.getItem('ui')) {

            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/permission', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        let result = JSON.parse(xhttp.responseText);
                        this.permission(result);
                    } else {
                        //handle error
                        modalAction.modalContent({title:"Something went wrong",content:result.errorMsg});
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }
        /*
        this.permission([
            { permissionId: 0, title: "Attendance", description: "Grant user permission to edit the startTime/EndTime and view All Staff atendance", staffIds: [{ staffId: "A0001", userName: "Ho Kok Liang" }, { staffId: "A0004", userName: "Loh Jik Nen" }] },
            { permissionId: 1, title: "Journey Planner", description: "Grant user permission to approve/reject each journey and send the list to account department", staffIds: [{ staffId: "A0001", userName: "Ho Kok Liang" }, { staffId: "A0004", userName: "Loh Jik Nen" }] },
            { permissionId: 2, title: "Leave Application", description: "Grant user permission to approve/reject leave application", staffIds: [{ staffId: "A0001", userName: "Ho Kok Liang" }, { staffId: "A0004", userName: "Loh Jik Nen" }] },
            { permissionId: 3, title: "Leave Summary", description: "Grant user permission to view other users leave summary", staffIds: [{ staffId: "A0001", userName: "Ho Kok Liang" }, { staffId: "A0004", userName: "Loh Jik Nen" }] },
            { permissionId: 4, title: "Employee Detail", description: "Grant user permission to view other employees detail", staffIds: [{ staffId: "A0001", userName: "Ho Kok Liang" }, { staffId: "A0004", userName: "Loh Jik Nen" }] },
            { permissionId: 5, title: "Employee Management", description: "Grant user permission to edit/add/remove employee detail", staffIds: [{ staffId: "A0001", userName: "Ho Kok Liang" }, { staffId: "A0004", userName: "Loh Jik Nen" }] },
            { permissionId: 6, title: "Contractor/Condo Management", description: "Grant user permission to edit/add/remove condos and contractors", staffIds: [{ staffId: "A0001", userName: "Ho Kok Liang" }, { staffId: "A0004", userName: "Loh Jik Nen" }] },
            { permissionId: 7, title: "Master CheckList", description: "Grant user permission to edit master checklist", staffIds: [{ staffId: "A0001", userName: "Ho Kok Liang" }, { staffId: "A0004", userName: "Loh Jik Nen" }] },
            { permissionId: 8, title: "Leave Management", description: "Grant user permission to edit employees annual leave", staffIds: [{ staffId: "A0001", userName: "Ho Kok Liang" }, { staffId: "A0004", userName: "Loh Jik Nen" }] },
            { permissionId: 9, title: "Permission Management", description: "To Allow user to modify permission", staffIds: [{ staffId: "A0001", userName: "Ho Kok Liang" }, { staffId: "A0004", userName: "Loh Jik Nen" }] },
        ]);
        this.processing(false);
        */
        return true;
    }
    updatePermission(permission){
        if (sessionStorage.getItem('ui')) {

            const xhttp = new XMLHttpRequest();
            xhttp.open("PUT", '/v1/api/permission', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        //show success message
                        modalAction.modalContent({title:"Successful",content:"You have updated the permission. Please refresh the browser"});
                        modalAction.modalClose(true);
                    } else {
                        let result = JSON.parse(xhttp.responseText);
                        //handle error
                        modalAction.modalContent({title:"Something went wrong",content:result.errorMsg});
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({permission: permission}));
        }
        return true;
    }
}
export default alt.createActions(permissionAction);


// WEBPACK FOOTER //
// ./app/actions/permissionAction.js